import type { AccessEvaluator } from "../types";

/**
 * Bespoke evaluator for `endusers`. The backend (`database.ts:1818-1841`,
 * mirrored in `api.ts:3596-3610`) grants a user access to an enduser when, for
 * `Default` or `Assigned` access (equivalent for this model — the `Assigned`
 * enduserId block is skipped because `endusers` is in
 * `MODELS_WITH_NO_ENDUSER_ID_TO_QUERY`):
 *
 *   assignedTo includes the user  OR  creator === user  OR
 *   (enableAccessTags is on AND the enduser's accessTags intersect the user's tags)
 *
 * `All` → granted. The accessTags grant is gated by the org's `enableAccessTags`
 * (`session.eat`); the hook folds that gate into `currentUserTags` (empty when
 * it's off), so this evaluator just checks for any intersection. The common
 * evaluator can't be used: it has no accessTags grant and would under-grant.
 */
export const ENDUSERS_ACCESS_EVALUATOR: AccessEvaluator<"endusers"> = {
  evaluate: ({ record, currentUserId, accessType, currentUserTags = [] }) => {
    switch (accessType) {
      case "All":
        return true;
      case "Default":
      case "Assigned": {
        if (record.assignedTo?.includes(currentUserId)) return true;
        if (record.creator === currentUserId) return true;
        return currentUserTags.length > 0 && !!record.accessTags?.some((tag) => currentUserTags.includes(tag));
      }
      default:
        return false;
    }
  },
};
